@for (blog of blogList(); track blog.slug) {
    <in2-card-box [card]="blog" [class]="getCardClassList(blog)" view-transition-source="{{ blog.slug }}"> </in2-card-box>
}
